import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { LanguageProvider } from "@/hooks/useLanguage";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Credibility from "@/components/Credibility";
import Benefits from "@/components/Benefits";
import Solutions from "@/components/Solutions";
import Marquee from "@/components/Marquee";
import Criteria from "@/components/Criteria";
import Comparison from "@/components/Comparison";
import SolutionFinder from "@/components/SolutionFinder";
import HowItWorks from "@/components/HowItWorks";
import FundingExample from "@/components/FundingExample";
import WhoWeHelp from "@/components/WhoWeHelp";
import About from "@/components/About";
import Faq from "@/components/Faq";
import Consultation from "@/components/Consultation";
import Footer from "@/components/Footer";
import Privacy from "@/pages/Privacy";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const Home = () => {
  const [prefill, setPrefill] = useState("");
  return (
    <main>
      <Hero />
      <Credibility />
      <Benefits />
      <Solutions />
      <Marquee />
      <Criteria />
      <Comparison />
      <SolutionFinder onSelect={setPrefill} />
      <HowItWorks />
      <FundingExample />
      <WhoWeHelp onSelect={setPrefill} />
      <About />
      <Faq />
      <Consultation prefill={prefill} />
    </main>
  );
};

function App() {
  useSmoothScroll();
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#202020",
              color: "#F4F0E9",
              border: "1px solid rgba(183,164,134,0.4)",
              borderRadius: 0,
            },
          }}
        />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
